module.exports = __webpack_public_path__ + "static/img/103.bdc82fbf.png";